module.exports = __webpack_public_path__ + "img/boomhut.b415a913.jpg";